// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_o2-2";
export var interactiveWrapper = "_o2-0";
export var shippingHoverPreview = "_o2-4";
export var summaryBadgeTrigger = "_o2-1";
export var widgetHoverPreviewList = "_o2-3";
export var widgetPreviewScale = "_o2-5";